import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Image, Link, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Text, useColorMode } from '@abb/uikit';
import { mode } from '@abb/uikit';
import { useGetNotificationImage } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoIconBold from 'shared-components/icons/InfoIconBold';
import NotificationLink from 'shared-components/icons/NotificationLink';
import { ReadMore } from 'shared-components/ReadMore/ReadMore';
export function NotificationDetailModal(param) {
    let { isOpen, onClose, notification } = param;
    const { t } = useTranslation('common');
    const { colorMode } = useColorMode();
    const { data: notificationImage } = useGetNotificationImage({
        shouldFetch: isOpen && !!(notification === null || notification === void 0 ? void 0 : notification.imageId),
        imageId: notification === null || notification === void 0 ? void 0 : notification.imageId
    });
    if (!notification) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isOpen,
        onClose: onClose,
        isCentered: true,
        motionPreset: "slideInBottom",
        scrollBehavior: "inside",
        size: "lg",
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                containerProps: {
                    px: 2
                },
                children: [
                    /*#__PURE__*/ _jsxs(ModalBody, {
                        padding: "24px 16px",
                        children: [
                            notificationImage ? /*#__PURE__*/ _jsx(Image, {
                                src: `data:image/png;base64,${notificationImage.imageContent}`,
                                borderRadius: "12px",
                                height: "250px",
                                width: "100%"
                            }) : /*#__PURE__*/ _jsx(InfoIconBold, {
                                color: "blue.400",
                                size: "33",
                                display: "block",
                                margin: "3px auto"
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                fontWeight: "700",
                                fontSize: "18px",
                                textAlign: "center",
                                mt: "32px",
                                mb: "24px",
                                children: notification.title
                            }),
                            notification.content.length > 150 ? /*#__PURE__*/ _jsx(ReadMore, {
                                children: notification.content
                            }) : /*#__PURE__*/ _jsx(Text, {
                                textAlign: "center",
                                children: notification.content
                            }),
                            notification.urlLink && /*#__PURE__*/ _jsx(Flex, {
                                background: mode('gray.50', 'whiteAlpha.50')({
                                    colorMode
                                }),
                                alignItems: "center",
                                padding: "8px 16px",
                                mt: "16px",
                                borderRadius: "6px",
                                borderWidth: "1px",
                                border: `1px solid ${mode('gray.200', 'gray.500')({
                                    colorMode
                                })}`,
                                cursor: "pointer",
                                children: /*#__PURE__*/ _jsxs(Link, {
                                    href: notification.urlLink,
                                    isExternal: true,
                                    display: "flex",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(NotificationLink, {}),
                                        /*#__PURE__*/ _jsx(Text, {
                                            as: "span",
                                            ml: "8px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            width: "300px",
                                            children: notification.urlLink
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ModalFooter, {
                        padding: "24px",
                        children: /*#__PURE__*/ _jsx(Button, {
                            width: "100%",
                            variant: "outline",
                            onClick: onClose,
                            children: t('actions.close')
                        })
                    })
                ]
            })
        ]
    });
}
